<template>
  <PSkeleton height="1.5rem" :width />
</template>

<script setup lang="ts">
import PSkeleton from "@/atoms/PSkeleton.vue";

defineProps<{ width?: string }>();
</script>
